import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/auth/AuthCallback";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import PublicLayout from "@/components/site/PublicLayout";
import Home from "@/pages/Home";
import Markets from "@/pages/Markets";
import StockDetail from "@/pages/StockDetail";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ClientDashboard from "@/pages/ClientDashboard";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminStocks from "@/pages/admin/AdminStocks";
import AdminProperties from "@/pages/admin/AdminProperties";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminClients from "@/pages/admin/AdminClients";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminKyc from "@/pages/admin/AdminKyc";
import AdminAudit from "@/pages/admin/AdminAudit";
import AdminTestimonials from "@/pages/admin/AdminTestimonials";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Verification from "@/pages/Verification";
import Legal from "@/pages/Legal";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/markets" element={<Markets />} />
        <Route path="/markets/:id" element={<StockDetail />} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/properties/:id" element={<PropertyDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<ProtectedRoute role="client"><ClientDashboard /></ProtectedRoute>} />
        <Route path="/verification" element={<ProtectedRoute role="client"><Verification /></ProtectedRoute>} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/terms" element={<Legal doc="terms" />} />
        <Route path="/privacy" element={<Legal doc="privacy" />} />
        <Route path="/risk-disclosure" element={<Legal doc="risk-disclosure" />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
        <Route index element={<AdminOverview />} />
        <Route path="stocks" element={<AdminStocks />} />
        <Route path="properties" element={<AdminProperties />} />
        <Route path="requests" element={<AdminRequests />} />
        <Route path="clients" element={<AdminClients />} />
        <Route path="enquiries" element={<AdminEnquiries />} />
        <Route path="verification" element={<AdminKyc />} />
        <Route path="audit" element={<AdminAudit />} />
        <Route path="testimonials" element={<AdminTestimonials />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
